import { List, ListItemButton, ListItemText, Typography } from "@mui/material";
import i18n from "i18next";
import { VerticalBox } from "src/components/common/box/VerticalBox.tsx";
import { SubConfigurationImportSourceOfferLine } from "src/components/views/erp/configurator/configuratorForm/impl/customerOfferLineSubConfigurationImportUtils.ts";

export interface CustomerOfferLineImportSourceLineListProps {
	lines: SubConfigurationImportSourceOfferLine[];
	selectedLineId: number | undefined;
	selectLine: (line: SubConfigurationImportSourceOfferLine) => void;
}

/** The offer lines from which sub-configurations can be imported. */
export function CustomerOfferLineImportSourceLineList({
	lines,
	selectedLineId,
	selectLine,
}: CustomerOfferLineImportSourceLineListProps) {
	return (
		<VerticalBox sx={{ borderRight: { md: 1 }, borderColor: "divider", overflow: "auto" }}>
			{lines.length === 0 ?
				<Typography color="text.secondary" sx={{ paddingX: 2 }}>
					{i18n.t("no_offer_lines_with_configuration")}
				</Typography>
			:	<List disablePadding>
					{lines.map((line) => (
						<ListItemButton
							key={line.customerOrderOfferLineId}
							selected={line.customerOrderOfferLineId === selectedLineId}
							onClick={() => selectLine(line)}
						>
							<ListItemText
								primary={`${line.lineNumber} – ${line.salesPartNo}`}
								secondary={line.configurationOrPartDescription}
							/>
						</ListItemButton>
					))}
				</List>
			}
		</VerticalBox>
	);
}
